import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-design/images/property-default-image.png'


const _withScopeId = n => (_pushScopeId("data-v-0e5698d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 view-tenant-review-history" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "content d-flex align-items-center justify-content-between" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = {
  class: "address details",
  style: {"margin-bottom":"8px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-map-marker-alt icon" }, null, -1))
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "dates details" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt icon" }, null, -1))
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-star text-warning me-1 star" }, null, -1))
const _hoisted_14 = { class: "rating" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantReviews, (review, key) => {
      return (_openBlock(), _createElementBlock("div", {
        onClick: ($event: any) => (_ctx.selectRentalHistory(review.reference_no)),
        key: key,
        class: _normalizeClass([{ selected: _ctx.isCurrent(review) }, "view-tenant-review-history-item d-flex align-items-center"])
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.getAddress(review)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getDates(review)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.toDecimal(review.average_rating)), 1)
          ])
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}